module.exports = __webpack_public_path__ + "img/textlogo.015b6825.svg";